export class Circle {
  size: number;
  radius: number;
  context: CanvasRenderingContext2D;
  centerX: number;
  centerY: number;
  frameCount: number;
  sensitivity: number;
  voiceData: any;

  constructor(
    context: CanvasRenderingContext2D,
    centerX: number,
    centerY: number,
    frameCount: number,
    voiceData: Uint8Array,
    sensitivity: number
  ) {
    this.size = 1;
    this.radius = window.innerWidth < 1100 ? window.innerWidth / 4 : 180;
    this.context = context;
    this.centerX = centerX;
    this.centerY = centerY;
    this.frameCount = frameCount;
    this.sensitivity = sensitivity;
    this.voiceData = voiceData;
  }
  update = () => {
    if (this.size > 0.2) this.size -= 0.05;
  };
  draw = () => {
    this.voiceData = [...this.voiceData];

    /* 16 total volume controlls */

    // const space = 12;
    // this.dataParm.forEach((value: number, i: number) => {
    //   this.context.lineWidth = 5;
    //   this.context.beginPath();
    //   this.context.moveTo(space * i + 20, this.centerY); //x,y
    //   this.context.lineTo(space * i + 20, this.centerY - value); //x,y
    //   this.context.stroke();
    //   this.context.lineWidth = 1;
    // });
    // console.log(dataParm.filter((x) => x != 0));
    // console.log(dataParm.length);

    // rings
    const getAvg = () => {
      let totalVolume = 0;
      for (let i = 0; i < this.voiceData.length; i++) {
        totalVolume += this.voiceData[i];
      }
      return totalVolume / this.voiceData.length / 255;
    };
    const getLow = () => {
      let totalVolume = 0;
      for (let i = 0; i < this.voiceData.length / 4; i++) {
        totalVolume += this.voiceData[i];
      }
      return totalVolume / (this.voiceData.length / 4) / 255;
    };
    const getHigh = () => {
      let totalVolume = 0;
      for (
        let i = this.voiceData.length - this.voiceData.length / 4;
        i < this.voiceData.length;
        i++
      ) {
        totalVolume += this.voiceData[i];
      }
      return totalVolume / (this.voiceData.length / 4) / 255;
    };
    const volume_low = getLow();
    const volume_avg = getAvg();
    const volume_high = getHigh();

    // context.scale(
    //   1 + frameCount * 0.01 * influence,
    //   1 + frameCount * 0.01 * influence
    // );
    const voice = {
      volume_low,
      volume_avg,
      volume_high,
    };
    // console.log("avg:", 0.8 - sensitivity / 4);
    // if volume avg is over x, then make it colorful!!
    const ringColor =
      volume_avg > 0.8 - this.sensitivity / 4
        ? Math.random() * 360
        : volume_avg * 360 * 2;
    const deg =
      volume_avg > 0.8 - this.sensitivity / 4
        ? this.frameCount / 10 + Math.random() * 15
        : this.frameCount / 10;
    this.context.lineWidth =
      volume_avg > 0.8 - this.sensitivity / 4 ? 1 : (1 / this.size) * 2;
    this.drawRing(
      this.context,
      this.centerX,
      this.centerY,
      this.radius,
      degree(deg),
      Math.floor(volume_avg * Math.pow(this.sensitivity * 2, 2.5)) + 3,
      `hsla(${
        -this.frameCount / 5 + ringColor + Math.pow(this.size, 3) * 100
      }, ${this.size > 0.5 ? "75%" : `${this.size * 10}%`}, 50%, ${
        this.size > 0.7 ? "100%" : `${this.size * 20}%`
      })`,
      this.frameCount,
      voice
    );
    // context.translate(-centerX, -centerY);
  };
  drawRing(
    context: CanvasRenderingContext2D,
    centerX: number,
    centerY: number,
    radius: number,
    angleOffset: number,
    minSide: number,
    color: string,
    frameCount: number,
    voice: { volume_low: any; volume_avg?: number; volume_high: any }
  ) {
    let counter = (360 / minSide) | 0; // floor to int

    for (var i = 360; i > 0; i -= counter) {
      let influence = voice.volume_low;
      // console.log(influence);
      var inner = voice.volume_high >= 0.5;
      if (inner) {
        influence = -influence;
      }
      let startAngle = i * radUnit + angleOffset;
      let midAngle = (i + counter / 2) * radUnit + angleOffset;
      let endAngle = (i + counter) * radUnit + angleOffset;
      let startX = radius * Math.cos(startAngle) + centerX,
        startY = radius * Math.sin(startAngle) + centerY,
        midX =
          radius *
            (this.sensitivity + voice.volume_low / 10 + influence * 3) *
            Math.cos(midAngle) +
          centerX,
        midY =
          radius *
            (this.sensitivity + voice.volume_low / 10 + influence * 3) *
            Math.sin(midAngle) +
          centerY,
        midXInner =
          radius *
            (this.sensitivity +
              voice.volume_high / 10 -
              influence * this.sensitivity * 5.5) *
            Math.cos(midAngle) +
          centerX,
        midYInner =
          radius *
            (this.sensitivity +
              voice.volume_high / 10 -
              influence * this.sensitivity * 5.5) *
            Math.sin(midAngle) +
          centerY,
        endX = radius * Math.cos(endAngle) + centerX,
        endY = radius * Math.sin(endAngle) + centerY;
      this.drawLine(
        context,
        startX,
        startY,
        midX,
        midY,
        endX,
        endY,
        color,
        frameCount
      );
      this.drawLine(
        context,
        startX,
        startY,
        midXInner,
        midYInner,
        endX,
        endY,
        color,
        frameCount
      );
      // drawDot(context, midX, midY, "yellow");
    }
  }

  drawLine(
    context: CanvasRenderingContext2D,
    startX: number,
    startY: number,
    midX: number,
    midY: number,
    endX: number,
    endY: number,
    color: string,
    influence: number
  ) {
    // console.log(startY);
    context.strokeStyle = color;
    context.beginPath();
    context.moveTo(startX, startY);
    // context.quadraticCurveTo(controlPointX,controlPointY,endPointX,endPointY);
    context.quadraticCurveTo(midX, midY, endX, endY);
    context.stroke();
  }
}

export const radUnit = Math.PI / 180;

export const FRAMES_PER_SECOND = 30; // Valid values are 60,30,20,15,10...
// set the mim time to render the next frame
export const FRAME_MIN_TIME =
  (1000 / 60) * (60 / FRAMES_PER_SECOND) - (1000 / 60) * 0.5;

export function degree(fromRad: number) {
  return fromRad * radUnit;
}
